import { useEffect, useState } from "react";
import iconFileTextOutline from "@iconify/icons-eva/file-text-outline";
import iconFileAddOutline from "@iconify/icons-eva/file-add-outline";
import iconPaperPlaneOutline from "@iconify/icons-eva/paper-plane-outline";
// material
import { Card, Table, Stack, TableRow, TableBody, TableCell, Container, Typography, TableContainer, TablePagination, TextField, Button, Grid, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
// components
import Page from "../../components/Page";
import Label from "../../components/Label";
import Scrollbar from "../../components/Scrollbar";
import SearchNotFound from "../../components/SearchNotFound";
import { Icon } from "@iconify/react";
import plusFill from "@iconify/icons-eva/plus-fill";

import moment from "moment";
import { PAYMENT_STATUS_MAP, PAY_METHODS, PAY_METHOD_MAP, STORE_ORDER_STATUS } from "src/config/constants";
import { alert } from "src/services/alert";
import MoreMenu from "src/components/common/MoreMenu";
import XLSX from "xlsx";
import FormDialog from "src/components/common/FormDialog";
import Confirm from "src/components/common/ConfirmDialog";
import ListHead from "src/components/common/ListHead";
import OrderRecordsDialog from "src/components/dialogs/OrderRecordsDialog";
import { asyncRequest } from "src/services/network";
import OrderDetailDialog from "src/components/dialogs/OrderDetailDialog";
import UserInfo from "src/components/common/UserInfo";
import PaymentListToolbar from "src/components/_dashboard/payment/PaymentListToolbar";
import PaymentAddDialog from "./components/PaymentAddDialog";
import MerchantInfo from "src/components/common/MerchantInfo";
import PaymentDetailDrawer from "./components/PaymentDetailDrawer";
import { useSelector } from "react-redux";
import MyPagination from "src/components/common/MyPagination";
import Decimal from "decimal.js"
// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: "name", label: "用户ID", alignRight: false },
  { id: "orderSN", label: "订单编号", alignRight: false },
  { id: "totalPrice", label: "总金额(元)", alignRight: false },
  { id: "price", label: "实付(元)", alignRight: false },
  { id: "payMethod", label: "支付方式", alignRight: false },
  { id: "status", label: "状态", alignRight: false },
  // { id: "receiverName", label: "收件人", alignRight: false },
  // { id: "receiverMobile", label: "收货人号码", alignRight: false },
  // { id: "receiverAddress", label: "收货地址", alignRight: false },
  { id: "merchant", label: "商家", alignRight: false },
  { id: "rangli", label: "让利", alignRight: false },
  // { id: "version", label: "版本", alignRight: false },
  { id: "created_at", label: "下单时间", alignRight: false },
  // { id: "supplier", label: "供应商", alignRight: false },
  { id: "" },
];

const methods = Object.values(PAY_METHODS);

const moreMenus = [
  // { title: "详情", icon: iconFileTextOutline },
  { title: "记录", icon: iconFileTextOutline },
  { title: "备注", icon: iconFileAddOutline },
  { title: "删除", icon: iconPaperPlaneOutline, limit: [STORE_ORDER_STATUS.FINISHED, STORE_ORDER_STATUS.DELETED, STORE_ORDER_STATUS.CANCELED] },
  { title: "手动关单", icon: iconPaperPlaneOutline, limit: [STORE_ORDER_STATUS.PENDING] },
  // { title: "退款", icon: iconPaperPlaneOutline, limit: [STORE_ORDER_STATUS.PAYED] },
  // { title: "确认支付", icon: iconPaperPlaneOutline, limit: [STORE_ORDER_STATUS.PENDING] },
  // { title: "手动转账", icon: iconPaperPlaneOutline, limit: [STORE_ORDER_STATUS.PAYED] },
  // { title: "分账查询", icon: iconPaperPlaneOutline, limit: [STORE_ORDER_STATUS.PAYED] },
];

export default function PaymentList() {
  const { username } = useSelector((state) => state.userInfo.userInfo);
  const [curOrder, setCurOrder] = useState({});
  const [action, setAction] = useState();
  const [remark, setRemark] = useState("");
  const [deliverySN, setDeliverySN] = useState(""); // 物流信息
  const [orders, setOrders] = useState([]);
  const [records, setRecords] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [countMap, setCountMap] = useState({});

  const [showAddDialog, setShowAddDialog] = useState(false);

  const [filter, setFilter] = useState({
    page: 0,
    size: 20,
    status: -1,
    payMethod: -1,
    search: "",
    createdAt: null,
  });

  useEffect(() => {
    getOrders();
  }, [filter]);

  async function getOrders() {
    const { data, count, counts } = await asyncRequest({
      path: "/payment/list",
      data: filter,
    });

    setOrders(
      data.map((d) => ({
        ...d,
        createdAt: moment(d.createdAt).format("YYYY-MM-DD HH:mm:ss"),
        payTime: d.payTime ? moment(d.payTime).format("YYYY-MM-DD HH:mm:ss") : d.payTime,
      }))
    );
    setTotalItems(count);

    const map = {};
    for (let i = 0; i < counts.length; i++) {
      map[counts[i].status] = counts[i].count;
    }
    setCountMap(map);
  }

  function handleSearch(val) {
    setFilter({
      ...filter,
      search: val,
    });
  }

  const handleChangePage = (event, newPage) => {
    setFilter({
      ...filter,
      page: newPage,
    });
  };

  const handleChangeRowsPerPage = (event) => {
    setFilter({
      ...filter,
      size: parseInt(event.target.value, 10),
      page: 0,
    });
  };

   const handlePageChange = (event, value, newSize) => {
    if (newSize !== undefined) {
      setFilter({ ...filter, page: 0, size: newSize });
      return;
    }
    const newPage = value - 1;
    if (newPage === filter.page) return;
    setFilter({
      ...filter,
      page: newPage,
    });
  };


  function handleDateChange(dateRange) {
    setFilter({
      ...filter,
      createdAt: dateRange,
    });
  }

  function handleStatusChange(status) {
    setFilter({
      ...filter,
      status,
    });
  }

  // 操作条
  async function handleDownload() {
    const { data } = await asyncRequest({
      path: "/payment/export",
      data: filter,
    });

    exportOrders(data.map((d) => ({ ...d, createdAt: moment(d.createdAt).format("YYYY-MM-DD HH:mm:ss"), payTime: d.payTime ? moment(d.payTime).format("YYYY-MM-DD HH:mm:ss") : d.payTime })));
  }

  function exportOrders(orders) {
    const alphabets = "ABCDEFGHIJKLMNOP".split("");
    const cellTitles = ["订单号", "用户ID", "手机号", "总金额", "抵扣金额", "付款金额", "支付方式", "商户", "让利额", "商户应收", "下单时间", "支付状态", "支付时间", "备注"];
    const cellKeys = ["orderSN", "uid", "mobile", "totalPrice", "deductionPrice", "payPrice", "payMethod", "merchantName", "rangli", "gain", "createdAt", "status", "payTime", "adminRemark"];
    const header = alphabets.slice(0, cellTitles.length);

    const _orders = orders.map((order) => {
      return {
        ...order,
        mobile: order.user.mobile,
        payMethod: PAY_METHOD_MAP[order.payMethod],
        status: PAYMENT_STATUS_MAP[order.status],
        merchantName: order.merchant.name,
        gain: parseFloat((order.totalPrice - order.rangli).toFixed(2)),
      };
    });

    const data = [];
    data[0] = {};
    for (let i = 0; i < header.length; i++) {
      const alphabet = header[i];
      data[0][alphabet] = cellTitles[i];

      for (let j = 0; j < _orders.length; j++) {
        if (!data[j + 1]) {
          data[j + 1] = {};
        }

        data[j + 1][alphabet] = _orders[j][cellKeys[i]];
      }
    }

    var ws = XLSX.utils.json_to_sheet(data, { header, skipHeader: true });

    var workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, ws, "订单信息");

    XLSX.writeFile(workbook, `订单导出${Date.now()}.xlsx`);
  }

  function filterMoreMenus(status) {
    const menus = [];
    for (let i = 0; i < moreMenus.length; i++) {
      if (moreMenus[i].limit && !moreMenus[i].limit.includes(status)) {
        continue;
      }

      menus.push(moreMenus[i]);
    }

    return menus;
  }

  async function getOrderRecords(orderSN) {
    const { data } = await asyncRequest({
      path: "/payment/records",
      data: { orderSN },
    });

    setRecords(data);
    setAction("records");
  }

  // 更多操作
  function handleMoreClick(title, row, ...args) {
    if (title === "详情") {
      setCurOrder(row);
      setAction("detail");
    } else if (title === "记录") {
      // setAction("records");
      getOrderRecords(row.orderSN);
    } else if (title === "发货") {
      setCurOrder(row);
      setAction("delivery");
    } else if (title === "备注") {
      setCurOrder(row);
      setRemark(row.adminRemark);
      setAction("remark");
    } else if (title === "退款") {
      refund(row.orderSN);
    } else if (title === "删除") {
      delRow(row.orderSN);
    } else if (title === "确认支付") {
      confirmPay(row.orderSN);
    } else if (title === "发放补贴") {
      sendButie(row.orderSN);
    } else if (title === "手动转账") {
      manualTransfer(row.orderSN);
    } else if (title === "分账查询") {
      queryFenzhang(row.orderSN);
    } else if (title == "手动关单") {
      confirmCancel(row.orderSN);
    }
  }

  function handleDialogConfirm() {
    if (action === "remark") {
      setAdminRemark();
    }
  }

  async function setAdminRemark() {
    const { data } = await asyncRequest({
      path: "/payment/remark",
      data: { orderSN: curOrder.orderSN, remark },
    });

    orders.find((t) => t.orderSN === curOrder.orderSN).adminRemark = remark;
    setOrders([...orders]);

    setAction();
  }

  async function confirmPay(orderSN) {
    Confirm({
      message: "确定完成支付吗？",
      async onConfirm() {
        const { msg } = await asyncRequest({
          path: "/payment/confirmPay",
          data: { orderSN },
        });

        setOrders(orders.filter((t) => t.orderSN !== orderSN));
        alert(msg, "success");
      },
    });
  }

  async function confirmCancel(orderSN) {
    Confirm({
      message: "确定取消支付吗？",
      async onConfirm() {
        const { msg } = await asyncRequest({
          path: "/payment/confirmCancel",
          data: { orderSN },
        });

        getOrders();
        alert(msg, "success");
      },
    });
  }

  async function manualTransfer(orderSN) {
    const { msg } = await asyncRequest({
      path: "/payment/mallbookFenzhang",
      data: { orderSN },
    });

    // setOrders(orders.filter((t) => t.orderSN !== orderSN));
    alert(msg, "success");
  }

  async function queryFenzhang(orderSN) {
    const { msg, data } = await asyncRequest({
      path: "/payment/profitsharing",
      data: { orderSN },
    });

    // setOrders(orders.filter((t) => t.orderSN !== orderSN));
    alert(data, "success");
  }

  async function sendButie(orderSN) {
    const { msg } = await asyncRequest({
      path: "/payment/sendButie",
      data: { orderSN },
    });

    alert(msg, "success");
  }

  function refund(orderSN) {
    Confirm({
      message: "确认退款吗？",
      async onConfirm() {
        const { data, msg } = await asyncRequest({
          path: "/payment/refund",
          data: { orderSN },
        });

        setOrders(orders.filter((t) => t.orderSN !== orderSN));
        alert(msg, "success");
      },
    });
  }

  function delRow(orderSN) {
    Confirm({
      message: "确定删除该条数据吗?",
      async onConfirm() {
        const { data, msg } = await asyncRequest({
          path: "/payment/del",
          data: { orderSN },
        });

        setOrders(orders.filter((t) => t.orderSN !== orderSN));
        alert(msg, "success");
      },
    });
  }

  function handleBulkSend(items) {
    Confirm({
      message: "确定批量发货吗？",
      async onConfirm() {
        const orders = [];

        for (let index = 0; index < items.length; index++) {
          const order = items[index];
          const vs = Object.values(order);

          if (!vs[14]) continue;

          orders.push({
            orderSN: vs[0],
            deliverySN: vs[14],
          });
        }

        // console.log(orders)

        const { msg } = await asyncRequest({
          path: "/payment/bulkFahuo",
          data: { orders },
        });

        alert(msg, "success");
        getOrders();
      },
    });
  }

  function handleFilterChange(ki, val) {
    setFilter({
      ...filter,
      [ki]: val,
    });
  }

  // const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - orders.length) : 0;
  const emptyRows = 0;

  return (
    <Page title="支付订单">
      <Container maxWidth="2000px">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            支付订单
          </Typography>

          <Button
            variant="contained"
            startIcon={<Icon icon={plusFill} />}
            onClick={() => {
              setShowAddDialog(true);
            }}
          >
            添加订单
          </Button>
        </Stack>

        <Card>
          <PaymentListToolbar total={totalItems} countMap={countMap} onDateChange={handleDateChange} onStatusChange={handleStatusChange} onSearch={handleSearch} onExport={handleDownload} onRefresh={getOrders}>
            <Grid container gap={1}>
              <Grid item sm={6} md={3}>
                <TextField
                  style={{ width: 200 }}
                  label="商户ID"
                  placeholder="商户ID"
                  autoComplete="off"
                  id="mid"
                  size="small"
                  value={filter.mid}
                  onChange={(e) => {
                    handleFilterChange("mid", e.target.value);
                  }}
                />
              </Grid>
            </Grid>

            <Grid item sm={6} md={3}>
              <FormControl size="small">
                <InputLabel>支付方式</InputLabel>
                <Select
                  label="支付方式"
                  value={filter.payMethod}
                  onChange={(e) => {
                    setFilter({
                      ...filter,
                      payMethod: e.target.value,
                    });
                  }}
                  style={{ width: 250 }}
                >
                  {[-1, ...methods].map((type, idx) => (
                    <MenuItem key={idx} value={type} name={type}>
                      {idx == 0 ? "全部" : PAY_METHOD_MAP[type]}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </PaymentListToolbar>

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <ListHead headLabel={TABLE_HEAD} />
                <TableBody>
                  {orders.map((row) => {
                    const { id, payPrice, merchant, totalPrice, createdAt, status, orderSN, payMethod, rangli, version, user } = row;
                    // const isItemSelected = selected.indexOf(nickname) !== -1;

                    return (
                      <TableRow hover key={id} tabIndex={-1} role="checkbox">
                        {/* <TableCell padding="checkbox">
                            <Checkbox
                              checked={isItemSelected}
                              onChange={(event) => handleClick(event, uid)}
                            />
                          </TableCell> */}
                        <TableCell align="left">
                          <UserInfo {...user} enablePreview />
                        </TableCell>
                        <TableCell align="left">{orderSN}</TableCell>
                        <TableCell align="left">{totalPrice}</TableCell>
                        <TableCell align="left">{payPrice}</TableCell>
                        <TableCell align="left">{PAY_METHOD_MAP[payMethod]}</TableCell>
                        <TableCell align="left">
                          <Label variant="ghost" color={["error", "success", "default", "default", "default", "default", "default"][status]}>
                            {PAYMENT_STATUS_MAP[status]}
                          </Label>
                        </TableCell>

                        <TableCell align="left">{!!merchant && <MerchantInfo enablePreview mid={merchant.mid} logo={merchant.logo} name={merchant.name} />}</TableCell>
                        <TableCell align="left">{parseFloat(Math.round((rangli / totalPrice) * 100))}%</TableCell>
                        {/* <TableCell align="left">{StringUtil.formatVersion(version)}</TableCell> */}

                        <TableCell align="left">{createdAt}</TableCell>

                        <TableCell align="right">
                          <Stack direction="row">
                            {/* {username == "admin" && ( */}
                            <Button
                              variant="text"
                              onClick={() => {
                                setCurOrder(row);
                                setAction("detail");
                              }}
                            >
                              详情
                            </Button>
                            {/* )} */}

                            <MoreMenu spread={false} menus={filterMoreMenus(status)} onMoreClick={(title) => handleMoreClick(title, row)} />
                          </Stack>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>
                {orders.length === 0 && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filter.search} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Stack direction="row" sx={{ p: 2 }}>
              {/* <Typography variant="caption" component="span">
                预期利润：{100}
              </Typography>
              <Divider orientation="vertical" flexItem sx={{mx: 1}} />
              <Typography variant="caption" component="span" >
                完单利润：{100}
              </Typography> */}
            </Stack>
            {/* <TablePagination labelRowsPerPage="每页行数" rowsPerPageOptions={[10, 20]} component="div" count={totalItems} rowsPerPage={filter.size} page={filter.page} onPageChange={handleChangePage} onRowsPerPageChange={handleChangeRowsPerPage} /> */}

            <MyPagination total={totalItems} page={filter.page} size={filter.size} onChange={handlePageChange} />
          </Stack>
        </Card>
      </Container>

      {/* 详情 */}
      <OrderDetailDialog order={curOrder} open={action === "detail2"} onClose={() => setAction()} />
      {action === "detail" && <PaymentDetailDrawer payment={curOrder} open onClose={() => setAction()} />}

      {/* 记录 */}
      <OrderRecordsDialog rows={records} open={action === "records"} onClose={() => setAction()} />

      <FormDialog title={`订单${curOrder.orderSN}备注`} open={action === "remark"} onConfirm={handleDialogConfirm} onClose={() => setAction()}>
        <TextField autoComplete="false" autoFocus id="adminRemark" value={remark} label="管理员备注" fullWidth variant="standard" onChange={(e) => setRemark(e.target.value)} />
      </FormDialog>

      {showAddDialog && (
        <PaymentAddDialog
          open
          onClose={() => setShowAddDialog(false)}
          onUpdate={() => {
            setShowAddDialog(false);
            getOrders();
          }}
        />
      )}
    </Page>
  );
}
